import overrides from './overrides';
import palette from './palette';
import typography from './typography';

export const muiTheme = {
	palette: {
		...palette,
		background: {
			default: '#F5F5FA',
			paper: '#ffffff'
		},
		text: {
			primary: '#0B132B',
			secondary: '#777777'
		},
		common: {
			white: '#ffffff',
			black: '#000000'
		}
	},
	typography,
	components: overrides,
	transitions: {
		create: (props, options) => {
			const { duration = 300, easing = 'ease-in-out' } = options || {};
			return `${props} ${duration}ms ${easing}`;
		},
		duration: {
			shortest: 150,
			shorter: 200,
			short: 250,
			standard: 300,
			complex: 375,
			enteringScreen: 225,
			leavingScreen: 195
		},
		easing: {
			easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
			easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
			easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
			sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
		}
	},
	spacing: (factor) => `${8 * factor}px`,
	shape: {
		borderRadius: 4
	},
	zIndex: {
		mobileStepper: 1000,
		fab: 1050,
		speedDial: 1050,
		appBar: 1100,
		drawer: 1200,
		modal: 1300,
		snackbar: 1400,
		tooltip: 1500
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 960,
			lg: 1280,
			xl: 1920
		},
		up: (key) => `@media (min-width:${muiTheme.breakpoints.values[key]}px)`,
		down: (key) => `@media (max-width:${muiTheme.breakpoints.values[key]}px)`
	}
};
